import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  deleteConsumedApi,
  deleteConsumedProvider,
  deleteConsumedComponent,
  getConsumedAPIByProviderId,
  getConsumedAPIByComponentId,
  getConsumedApiAdvanceSearch,
  getConsumedApiAutoSuggest,
  getConsumedProvider,
  getConsumedProviderAdvanceSearch,
  getConsumedProviderAutoSuggest,
  getConsumedComponentAdvanceSearch,
  getConsumedComponentAutoSuggest,
  getConsumedComponentByProviderId,
  saveConsumedApi,
  saveConsumedApiBatch,
  saveConsumedApiBatchState,
  saveConsumedProvider,
  saveConsumedProviderState,
  saveConsumedComponent,
  saveConsumedComponentState,
  setAPIByProviderId,
  setAPIByComponentId,
  setComponentByProviderId,
  setDeleteConsumedApi,
  setDeleteConsumedProvider,
  setDeleteConsumedComponent,
  setConsumedApi,
  setConsumedApiAdvanceSearch,
  setConsumedApiAutosuggest,
  setConsumedProvider,
  setConsumedProviderAdvanceSearch,
  setConsumedProviderAutosuggest,
  setConsumedProviderTable,
  setConsumedComponentAdvanceSearch,
  setConsumedComponentAutosuggest
} from '../actions/consumedrest.actions';
import { MessageService } from 'primeng/api';

@Injectable()
export class ConsumedrestEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);

  getConsumedProvider$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedProvider),
        map((action) =>
          this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setConsumedProviderTable({ consumedProviderTable: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  saveConsumedProvider$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveConsumedProvider),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](
            action.saveAPiConstants,
            action.consumedProviderData
          ).subscribe(
            (result: any) => {
              if (result) {
                console.log(result);
                this.store.dispatch(setConsumedProvider({ consumedProvider: result }));
                this.store.dispatch(saveConsumedProviderState({ success: true, consumedProvider: result }));
              }
            },
            (error) => {
              if (error.status === 500) {
                this.showMessage('error', 'Exception while creating Provider');
              } else if (error.status === 403) {
                this.showMessage('error', 'Access restricted');
              } else {
                this.showMessage('error', 'The provider already exists');
              }
              this.store.dispatch(
                saveConsumedProviderState({ success: false, consumedProvider: action.consumedProviderData })
              );
            }
          )
        )
      ),
    { dispatch: false }
  );

  saveConsumedApi$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveConsumedApi),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](action.saveAPiConstants, action.consumedApiData).subscribe(
            (result: any) => {
              if (result) {
                this.store.dispatch(
                  setConsumedApi({
                    consumedApi: result
                  })
                );
              }
            }
          )
        )
      ),
    { dispatch: false }
  );

  saveConsumedComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveConsumedComponent),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](
            action.saveAPiConstants,
            action.consumedComponentData
          ).subscribe(
            (result: any) => {
              if (result) {
                console.log(result);
                this.store.dispatch(saveConsumedComponentState({ success: true, consumedComponent: result }));
              }
            },
            (error) => {
              if (error.status === 500) {
                this.showMessage('error', 'Exception while creating component');
              } else if (error.status === 403) {
                this.showMessage('error', 'Access restricted');
              } else {
                this.showMessage('error', 'A component with same name under Provider already exists');
              }
              this.store.dispatch(
                saveConsumedComponentState({ success: true, consumedComponent: action.consumedComponentData })
              );
            }
          )
        )
      ),
    { dispatch: false }
  );

  saveConsumedApiBatch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveConsumedApiBatch),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](
            action.saveAPiConstants,
            action.consumedApiDataBatch
          ).subscribe(
            (result: any) => {
              if (result) {
                console.log(result);
                this.store.dispatch(
                  setAPIByComponentId({ componentId: result[0].componentId, consumedAPIByComponent: result })
                );
                this.store.dispatch(
                  saveConsumedApiBatchState({ success: true, consumedApiBatch: action.consumedApiDataBatch })
                );
              }
            },
            (error) => {
              this.showMessage('error', 'An API already exists, please refresh and check');
              this.store.dispatch(saveConsumedApiBatchState({ success: false, consumedApiBatch: null }));
            }
          )
        )
      ),
    { dispatch: false }
  );

  getConsumedAPIByComponentId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedAPIByComponentId),
        map((action) =>
          this.baseService[action.getConsumedAPIByComponentIdApi?.method](
            action.getConsumedAPIByComponentIdApi,
            action.params
          ).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(
                setAPIByComponentId({ componentId: action.params.functionalcompid, consumedAPIByComponent: result })
              );
            }
          })
        )
      ),
    { dispatch: false }
  );

  getConsumedAPIByProviderId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedAPIByProviderId),
        map((action) =>
          this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(
                setAPIByProviderId({ providerId: action.params.providerId, consumedAPIByProvider: result })
              );
            }
          })
        )
      ),
    { dispatch: false }
  );

  setAPIByProviderId;

  getConsumedComponentByProviderId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedComponentByProviderId),
        map((action) =>
          this.baseService[action.getConsumedComponentByProviderIdApi?.method](
            action.getConsumedComponentByProviderIdApi,
            action.params
          ).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setComponentByProviderId({ consumedComponentByProvider: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  deleteConsumedProvider$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteConsumedProvider),
        map((action) => {
          if (!action.deleteApiConstants?.method) {
            return;
          }
          this.baseService[action.deleteApiConstants.method](action.deleteApiConstants, action.ids).subscribe(
            (result: any) => {
              this.store.dispatch(setDeleteConsumedProvider({ deletedProvider: true }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  deleteConsumedComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteConsumedComponent),
        map((action) => {
          if (!action.deleteApiConstants?.method) {
            return;
          }
          this.baseService[action.deleteApiConstants.method](action.deleteApiConstants, action.ids).subscribe(
            (result: any) => {
              this.store.dispatch(setDeleteConsumedComponent({ deletedComponent: true }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  deleteConsumedApi$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteConsumedApi),
        map((action) => {
          if (!action.deleteApiConstants?.method) {
            return;
          }
          this.baseService[action.deleteApiConstants.method](action.deleteApiConstants, action.ids).subscribe(
            (result: any) => {
              this.store.dispatch(setDeleteConsumedApi({ deletedApi: true }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  getConsumedComponentAutoSuggest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedComponentAutoSuggest),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setConsumedComponentAutosuggest({ componentAutosuggestResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getConsumedApiAutoSuggest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedApiAutoSuggest),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setConsumedApiAutosuggest({ apiAutosuggestResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getConsumedProviderAutoSuggest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedProviderAutoSuggest),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setConsumedProviderAutosuggest({ providerAutosuggestResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getConsumedComponentAdvanceSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedComponentAdvanceSearch),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setConsumedComponentAdvanceSearch({ componentAdvanceSearchRsults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getConsumedApiAdvanceSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedApiAdvanceSearch),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setConsumedApiAdvanceSearch({ apiAdvanceSearchResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getConsumedProviderAdvanceSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getConsumedProviderAdvanceSearch),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setConsumedProviderAdvanceSearch({ providerAdvanceSearchtResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
